import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchShiftListing,
  setShiftListingLoading,
  updateShiftListingPagination,
} from "@/reducers/clientdashboard";

import { ShiftListingTable } from "./ShiftListingTable";
import { ShiftListingTop } from "./ShiftListingTop";

/**
 * ShiftListing component for displaying and managing shift listings.
 */
export const ShiftListing = () => {
  const dispatch = useDispatch();
  const { rightSideShiftScheduleFilter, shiftListingPagination } = useSelector(
    (state) => state.clientDashboard,
  );
  const listingWrapper = useRef(null);

  useEffect(() => {
    dispatch(setShiftListingLoading(true));
    dispatch(
      updateShiftListingPagination({
        ...shiftListingPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    setTimeout(() => {
      dispatch(fetchShiftListing());
    }, 300);
  }, []);
  const firstUpdateByShiftType = useRef(true);
  const firstUpdatebySearch = useRef(true);
  useEffect(() => {
    if (firstUpdateByShiftType.current) {
      firstUpdateByShiftType.current = false;
      return;
    }

    dispatch(setShiftListingLoading(true));
    dispatch(
      updateShiftListingPagination({
        ...shiftListingPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchShiftListing());
  }, [
    rightSideShiftScheduleFilter.shift_type,
    rightSideShiftScheduleFilter.shift_date,
  ]);
  useEffect(() => {
    if (firstUpdatebySearch.current) {
      firstUpdatebySearch.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setShiftListingLoading(true));
      dispatch(
        updateShiftListingPagination({
          ...shiftListingPagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchShiftListing());
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [rightSideShiftScheduleFilter.search]);

  return (
    <div
      className="ShiftListing_Wrapper grow overflow-hidden"
      ref={listingWrapper}
    >
      <div className="tour-dashboard-oneMonth-calendar flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <ShiftListingTop />
        <ShiftListingTable />
      </div>
    </div>
  );
};
